import React, { useState } from "react"

interface Props {
  name: string
  sortby: string
  onSortChanged?: any
  sort?: boolean
}

export const BooksTableHeaderItem = ({ name, sortby, onSortChanged, sort }: Props) => {
  const [asc, setAsc] = useState(true)
  const onSort = (sort: string, asc: boolean) => {
    onSortChanged(sort, asc)
    setAsc(!asc)
  }
  return (
    <>
      <div onClick={() => onSort(sortby, asc)}>
        {name}
        {sort}&nbsp;{sort ? (asc ? "▼" : "▲") : ""}
      </div>
    </>
  )
}
